// src/components/Timer/ProgressBar.js

import React from 'react';

function ProgressBar({ timeLeft, duration }) {
  const percentage = Math.round(((duration - timeLeft) / duration) * 100) || 0;

  return (
    <div className="progress-bar">
      <div className="progress" style={{ width: `${percentage}%` }}></div>
    </div>
  );
}

export default ProgressBar;
